import es from 'date-fns/locale/es';
import { ComponentProps } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';

import InputError from '../InputError';
import Label from '../Label';

import DatePickerCustomDay from './DatePickerCustomday';

import { cn } from '@/utils';
import { inputTextBaseClass } from '@/utils/constants';

registerLocale('es', es);

type CalendarType = ComponentProps<typeof DatePicker>;
export type CalendarTypeValue = CalendarType['value'];

type Props = CalendarType & {
  label?: string;
  error?: string;
};

const InputDatePicker = ({ label, maxDate, error, ...rest }: Props) => {
  const inputClass = cn(inputTextBaseClass, {
    'border-gdt-status-red': error,
  });

  return (
    <fieldset className="space-y-1">
      <div className="space-y-[10px]">
        {label && <Label htmlFor="birthDate">{label}</Label>}
        <div className="relative">
          <DatePicker
            showMonthDropdown
            showYearDropdown
            className={inputClass}
            dateFormat="dd/MM/yyyy"
            dropdownMode="select"
            locale="es"
            maxDate={maxDate}
            placeholderText="DD/MM/AAAA"
            renderDayContents={(day, date) => (
              <DatePickerCustomDay date={date} dayOfMonth={day} />
            )}
            showPopperArrow={false}
            onFocus={(e) => (e.target.readOnly = true)}
            onKeyDown={(e) => {
              e.preventDefault();
            }}
            {...rest}
          />
          {error && <InputError.Icons error={error} />}
        </div>
        {error && <InputError.Label>{error}</InputError.Label>}
      </div>
    </fieldset>
  );
};

export default InputDatePicker;
